import { z } from 'zod';

export const CannedResponseSchemaData = z.object({
  shorthand: z.string(),
  message: z.string(),
});

export const CannedResponseSchema = CannedResponseSchemaData.extend({
  identifier: z.string(),
});
